<template>
  <div :style="{ 'display': (inline ? 'inline-block' : 'block') }">
    <v-hover v-slot="{ isHovering, props }">
      <a :href="instagramUrl" target="_blank">
        <span v-if="hideIcon">{{ username }}</span>
        <v-icon v-else class="mr-1" :class="{ 'on-hover': isHovering }" v-bind="props">mdi-instagram</v-icon>{{ username }}
      </a>
    </v-hover>
  </div>
</template>

<script>
export default {
  name: 'LinkedInComponent',
  props: {
    instagram: String,
    hideIcon: { type: Boolean, default: false},
    hideUsername: { type: Boolean, default: false},
    inline: { type: Boolean, default: false},
  },
  computed: {
    instagramUrl() {
      if (this.instagram.startsWith('http')) {
        return this.instagram;
      } else if (this.instagram.indexOf('/') !== -1) {
        return "https://" + this.instagram;
      } else {
        return `https://www.instagram.com/in/${this.instagram}`;
      }
    },
    username() {
      if (this.hideUsername) {
        return '';
      }
      return this.instagram.split('/').pop();
    }
  }
}
</script>

<style scoped>
a {
  color: rgb(0, 0, 238);
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
.on-hover {
  transition: transform 0.3s ease;
  transform: scale(1.3); /* Increase the size by 20% */
}
</style>